import * as fetcher from "../helpers/fetcher";

export async function getProduct(address, access_token) {
  return fetcher.get(`/products/${address}`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getCategories(access_token) {
  return fetcher.get(`/categories`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getCategory(id, access_token) {
  return fetcher.get(`/categories/${id}`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getSubcategory(id, access_token) {
  return fetcher.get(`/categories/subcategory/${id}`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getBestsellers(access_token) {
  return fetcher.get(`/meals/bestsellers`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getFishOfTheWeek(access_token) {
  return fetcher.get(`/meals/fish-of-the-week`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getSearch(access_token, search) {
  return fetcher.get(
    `/search`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    { search: search }
  );
}
